export default __webpack_public_path__ + "static/media/ShipsRoRoRamps-selected.a9498ac8.png";